import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import { withComponentPreview } from '@wix/editor-elements-preview-utils';
import React from 'react';
import type { IWTwitterFollowProps } from '../WTwitterFollow.types';

const withCustomUrl =
  (WrappedComponent: React.ComponentType<IWTwitterFollowProps>) =>
  (props: IWTwitterFollowProps) => (
    <WrappedComponent {...props} currentUrl="https://www.wix.com" />
  );

export default (ViewerComponent: React.ComponentType<IWTwitterFollowProps>) =>
  createComponentPreviewEntry(
    withComponentPreview(withCustomUrl(ViewerComponent)),
  );
